import React, { useMemo } from 'react';
import { isEmpty } from '@/shared/utility';
import GameCard from '@/pages/games/game-card/GameCard';
import { GamesStreamlineSectionCommonProps } from '@/components/shared/games/GamesStreamlineSection';
import Single from '@/components/shared/streamline/children-layouts/Single';
import Streamline from '@/components/shared/streamline/Streamline';

function GamesSingleStreamline({
  games,
  category,
}: GamesStreamlineSectionCommonProps): JSX.Element {
  const children = useMemo(() => {
    if (isEmpty(games)) return <div />;
    return games.map(game => (
      <Single key={`/${category}/${game.slug}/${game.gameId}`}>
        <GameCard game={game} category={category} />
      </Single>
    ));
  }, [games, category]);

  return <Streamline children={children} />;
}

export default GamesSingleStreamline;
